// @ts-nocheck
import * as React from 'react';
import {Navigate} from 'react-router'

import { HomePage } from './pages/HomePage/Loadable';
import { InferPage } from './pages/InferPage/Loadable';
import { InstrumentInferPage } from './pages/InstrumentInferPage/Loadable';
import { TrainingPage } from './pages/TrainingPage/Loadable';
import { VoiceModelsPage } from './pages/VoiceModelsPage/Loadable';
import { JobsPage } from './pages/JobsPage/Loadable';
import { NotFoundPage } from './components/NotFoundPage/Loadable';
import { AuthenticatedRoute } from 'app/components/AuthenticatedRoute';
import { SellerAuthenticatedRoute } from 'app/components/SellerAuthenticatedRoute';
import Login from './pages/Auth/Login';
import {UpgradePage} from "app/pages/UpgradePage";
import {RefillPage} from "app/pages/RefillPage/Loadable";
import {FaqsPage} from "app/pages/FaqsPage/Loadable";
import {LandingPage} from "app/pages/LandingPage/Loadable";
import {AcapellasPage} from "app/pages/AcapellasPage";
import {UserAcapellasPage} from "app/pages/UserAcapellasPage/Loadable";
import {SellerCreateAcapellaStackPage} from "app/pages/SellerCreateAcapellaStackPage";
import {LearnPage} from "app/pages/LearnPage/Loadable";
import {AcapellaStackDetailsPage} from "app/pages/AcapellaStackDetailsPage/Loadable";
import {MyLibraryPage} from "app/pages/MyLibraryPage/Loadable";
import {PaymentSuccessPage} from "app/pages/PaymentSuccessPage/Loadable";
import {SplitStemsPage} from "app/pages/SplitStemsPage/Loadable";
import { StemSplitJobsPage } from './pages/StemSplitJobsPage/Loadable';
import { LyricsToMusicJobsPage } from './pages/LyricsToMusicJobsPage/Loadable';
import {TTSPage} from "app/pages/TTSPage/Loadable";
import { MusicGenPage } from './pages/MusicGenPage/Loadable';

export const authRoutes = [
    {path: 'welcome', element: <HomePage/>, title: "Welcome to Controlla"},
    {path: 'learn', element: <LearnPage/>, title: "Learn" },
    {path: 'acapellas', element: <AcapellasPage/>, title: "Acapellas" },
    {path: 'acapellas/:acapellaStackUuid', element: <AcapellaStackDetailsPage/>, title: "Song" },
    {path: 'library', element: <MyLibraryPage/>, title: "My Acapellas", children: [
            {
                path: 'songs',
                element: <UserAcapellasPage/>,
                title: "My Songs",
            },
            {
                path: 'swaps',
                element: <JobsPage/>,
                title: "My Voice Swaps",
            },
            {
                path: 'splits',
                element: <StemSplitJobsPage/>,
                title: "My Stem Splits",
            },
            {
                path: 'samples',
                element: <LyricsToMusicJobsPage/>,
                title: "My Style Samples",
            },
        ]
    },
    {path: 'instruments', element: <InstrumentInferPage/>, title: "Audio to Instrument"},
    {path: 'generate', element: <InferPage/>, title: "Swap Voice"},
    {path: 'stem-splitter', element: <SplitStemsPage/>, title: "Split Stems"},
    {path: 'tts', element: <TTSPage/>, title: "Text to Speech"},
    {path: 'text-to-song', element: <MusicGenPage />, title: "Song To Song"},
    {path: 'train', element: <TrainingPage/>, title: "Create a Voice"},
    {path: 'voice-models', element: <VoiceModelsPage/>, title: "My Voices"},
    {path: 'upgrade', element: <UpgradePage/>, title: "Upgrade"},
    {path: 'refill', element: <RefillPage/>, title: "Refill"},
    {path: 'faqs', element: <FaqsPage />, title: "FAQs"},
    {path: 'success', element: <PaymentSuccessPage />, title: "Thanks for Upgrading"},
];

export const sellerRoutes = [
    {path: 'create-acapella', element: <SellerCreateAcapellaStackPage/>, title: "Upload Acapella Stack"},
];

// Only paths here are rendered as main items in desktop navbar
export const getTitleForPath = (path) => {
    switch (path) {
        case "acapellas":
            return "Songs";
        case "library":
            return "My Library";
        case "generate":
            return "Swap Voice";
        case "stem-splitter":
            return "Split Stems";
        case "text-to-song":
            return "Style Sampler";
        case "train":
            return "Create a Voice";
        case "voice-models":
            return "My Voices";
        default:
            return null;
    }
}

export const routes = [
    {
        path: '/login',
        element: <Login />
    },
    {
        path: '/',
        element: <LandingPage />,
    },
    {
        // default to songs page in my library
        path: '/app/library',
        element: <Navigate to={"/app/library/songs"} />,
    },
    {
        path: '/app/',
        element: <AuthenticatedRoute />,
        children: authRoutes,
    },

    {
        path: '/sell/',
        element: <SellerAuthenticatedRoute />,
        children: sellerRoutes,
    },
    {
        // backwards compatible with old redirects from backend or auth etc.
        path: '/voice-models',
        element: <Navigate to={"/app/voice-models"} />,
    },
    {
        // backwards compatible with old redirects from backend or auth etc.
        path: '/generate',
        element: <Navigate to={"/app/generate"} />,
    },
    {
        // backwards compatible with old redirects from backend or auth etc.
        path: '/train',
        element: <Navigate to={"/app/train"} />,
    },
    {
        // backwards compatible with old redirects from backend or auth etc.
        path: '/upgrade',
        element: <Navigate to={"/app/upgrade"} />,
    },
    {
        // backwards compatible with old redirects from backend or auth etc.
        path: '/refill',
        element: <Navigate to={"/app/refill"} />,
    },
    {
        // backwards compatible with old redirects from backend or auth etc.
        path: '/history',
        element: <Navigate to={"/app/library/swaps"} />,
    },
    {
        // backwards compatible with old redirects from backend or auth etc.
        path: '/app/history',
        element: <Navigate to={"/app/library/swaps"} />,
    },
    {
        // backwards compatible with old redirects from backend or auth etc.
        path: '/acapellas',
        element: <Navigate to={"/app/acapellas"} />,
    },
    {
        // backwards compatible with old instrument page
        path: '/app/instruments',
        element: <Navigate to={"/app/generate"} />,
    },
    {
        path: '*',
        element: <NotFoundPage />
    }
];